/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { type ContextModalProps } from '@mantine/modals';
import type { OpenContextModal } from '@mantine/modals/lib/context';

export type FooterlessModalType = OpenContextModal<Partial<FooterlessModalProps>>;

interface FooterlessModalProps {
  modalBody?: JSX.Element;
}

export default function FooterlessModal({ innerProps }: ContextModalProps<FooterlessModalProps>) {
  return innerProps.modalBody;
}
